import React from "react";
import sliderContent from "assets/images/chpt/slider-content.png";
import close from "assets/images/chpt/close.png";
import cryFace from "assets/images/chpt/crying-face.png";
import trophy from "assets/images/chpt/trophy.png";
import bannerCard from "assets/images/chpt/banner-card.png";
import { Button } from "reactstrap";
import { motion } from "framer-motion/dist/framer-motion";
import {
  divVariants,
  slide_bounce_variants,
  slide_bounce_down_variants
} from "shared/components/animations";
const CHPTCardModal = ({
  card,
  isresultModal = false,
  crossButtonClick = () => {},
  buttonClick = () => {},
  winnerButtonClick = () => {},
  isWinnerPlayer,
  isNewCard = false,cancelSelect=false
}) => {
  console.log("card",card);
  return (
    <motion.div
      variants={cancelSelect? slide_bounce_down_variants : slide_bounce_variants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="chpt-card-modal-wrapper"
    >
      <div className="chpt-card-modal">
        {isresultModal ? (
          <>
            {isWinnerPlayer ? (
              <>
                <img className="trophy" src={trophy} alt="trophy" />
                <div className="you-won">
                  <img src={bannerCard} alt="bannerCard" />
                  <h3>You won this round!</h3>
                </div>
                <div className="card-content">
                  <img src={card?.url} alt="sliderContent" />
                </div>
                <Button
                  className="blue-solid-btn"
                  onClick={() => winnerButtonClick()}
                >
                 
                  NEXT PLAYER
                </Button>
              </>
            ) : (
              <>
                <div className="title-head">
                  <h5>SORRY LOSER!</h5>
                  <img  src={close}  onClick={() => crossButtonClick()} alt="close" />
                </div>
                <img src={cryFace} alt="cryFace" className="cry-face" />
                <div className="card-content">
                  <img src={card?.url} alt="sliderContent" />
                </div>
                <Button  onClick={() => crossButtonClick()}  className="blue-solid-btn"> CONTINUE</Button>
              </>
            )}
          </>
        ) : (
          <>
            <div className="title-head">
              <h5>{isNewCard ? "NEW CARD" : "ARE YOU SURE ?"}</h5>
              <img src={close} alt="close" onClick={() => crossButtonClick()} />
            </div>
            <div className="card-content">
              <img src={card?.url} alt="sliderContent" />
            </div>
            <Button className="blue-solid-btn " onClick={() => buttonClick()}>
              {isNewCard ? "OK" : "CONFIRM"}
            </Button>{" "}
          </>
        )}
      </div>
    </motion.div>
  );
};

export default CHPTCardModal;
